import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'
import * as Dtos from '../../dtos/Fig.dtos';

import {
    ACTION_GLIOBLASTOMADETAILFORMS_LOAD,
    ACTION_GLIOBLASTOMADETAILFORMS_LOAD_BY_ID,
    ACTION_GLIOBLASTOMADETAILFORMS_LOAD_BY_PATIENT_ID,
    ACTION_GLIOBLASTOMADETAILFORMS_LOAD_BY_PATIENT_IDENTIFIER,
    ACTION_GLIOBLASTOMADETAILFORMS_LOAD_SUCCESS,
    ACTION_GLIOBLASTOMADETAILFORMS_LOAD_FAILURE,

    ACTION_GLIOBLASTOMADETAILFORMS_SAVE,
    ACTION_GLIOBLASTOMADETAILFORMS_SAVE_SUCCESS,
    ACTION_GLIOBLASTOMADETAILFORMS_SAVE_FAILURE,

    ACTION_GLIOBLASTOMADETAILFORMS_CREATE,
    ACTION_GLIOBLASTOMADETAILFORMS_CREATE_SUCCESS,
    ACTION_GLIOBLASTOMADETAILFORMS_CREATE_FAILURE,

    ACTION_GLIOBLASTOMADETAILFORMS_CLEAR,
    GlioblastomaDetailFormAction
} from '../../actions/forms/glioblastomaDetailForm';

import { RequestState } from "../../enumerations/RequestState";
import { IRequestState } from "../index";
import { updateFailureIndexToId } from "../../helpers/formErrorHelper";

export interface IGlioblastomaDetailFormState {
    formData: Dtos.GlioblastomaDetailForm | Dtos.GlioblastomaDetailForm[],
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    validationFailures: Dtos.ResponseError[];
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    createState: IRequestState;
}

const initialState: IGlioblastomaDetailFormState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    validationFailures: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState
};


function loading(state: IGlioblastomaDetailFormState, isLoading: boolean): IGlioblastomaDetailFormState {
    const newState: IGlioblastomaDetailFormState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: IGlioblastomaDetailFormState,
    formData: Dtos.GlioblastomaDetailForm | Dtos.GlioblastomaDetailForm[],
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    lookups: Dtos.Lookup[], responseStatus: Dtos.ResponseStatus
): IGlioblastomaDetailFormState {
    const newState: IGlioblastomaDetailFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function loadFailure(state: IGlioblastomaDetailFormState, responseStatus: Dtos.ResponseStatus): IGlioblastomaDetailFormState {
    const newState: IGlioblastomaDetailFormState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function saving(state: IGlioblastomaDetailFormState, isSaving: boolean): IGlioblastomaDetailFormState {
    const newState: IGlioblastomaDetailFormState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: IGlioblastomaDetailFormState,
    formData: Dtos.GlioblastomaDetailForm | Dtos.GlioblastomaDetailForm[],
    formState: Dtos.RegistrationFormState,
    responseStatus: Dtos.ResponseStatus
): IGlioblastomaDetailFormState {
    const newState: IGlioblastomaDetailFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        },
        validationFailures: {
            $set: responseStatus ? updateFailureIndexToId(responseStatus.errors, formData) : undefined
        }
    });

    return newState;
}

function saveFailure(state: IGlioblastomaDetailFormState, responseStatus: Dtos.ResponseStatus): IGlioblastomaDetailFormState {
    const newState: IGlioblastomaDetailFormState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        }
    });

    return newState;
}

function creating(state: IGlioblastomaDetailFormState, isCreating: boolean): IGlioblastomaDetailFormState {
    const newState: IGlioblastomaDetailFormState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: IGlioblastomaDetailFormState,
    formData: Dtos.GlioblastomaDetailForm,
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    lookups: Dtos.Lookup[]
): IGlioblastomaDetailFormState {
    const newState: IGlioblastomaDetailFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: IGlioblastomaDetailFormState, responseStatus: Dtos.ResponseStatus): IGlioblastomaDetailFormState {
    const newState: IGlioblastomaDetailFormState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: IGlioblastomaDetailFormState): IGlioblastomaDetailFormState {
    const newState: IGlioblastomaDetailFormState = update(initialState, {});

    return newState;
}

const GlioblastomaDetailFormReducer: Reducer<IGlioblastomaDetailFormState> = (state: IGlioblastomaDetailFormState = initialState, action: GlioblastomaDetailFormAction) => {
    switch (action.type) {
        case ACTION_GLIOBLASTOMADETAILFORMS_LOAD:
        case ACTION_GLIOBLASTOMADETAILFORMS_LOAD_BY_ID:
        case ACTION_GLIOBLASTOMADETAILFORMS_LOAD_BY_PATIENT_ID:
        case ACTION_GLIOBLASTOMADETAILFORMS_LOAD_BY_PATIENT_IDENTIFIER:
            return loading(state, true);
        case ACTION_GLIOBLASTOMADETAILFORMS_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_GLIOBLASTOMADETAILFORMS_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_GLIOBLASTOMADETAILFORMS_SAVE:
            return saving(state, true);
        case ACTION_GLIOBLASTOMADETAILFORMS_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_GLIOBLASTOMADETAILFORMS_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_GLIOBLASTOMADETAILFORMS_CREATE:
            return creating(state, true);
        case ACTION_GLIOBLASTOMADETAILFORMS_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_GLIOBLASTOMADETAILFORMS_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_GLIOBLASTOMADETAILFORMS_CLEAR:
            return clear(state);
    }

    return state;
}

export default GlioblastomaDetailFormReducer;